var _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _g2, _path, _g3, _path2, _g4, _circle, _circle2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 95,
    viewBox: "0 0 118 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_937_16323)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_16323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3503 15.6341C23.0447 15.3254 22.6807 15.0806 22.2795 14.9141C21.8783 14.7476 21.448 14.6626 21.0136 14.6641C19.1936 14.6641 17.7103 16.1474 17.7103 17.9674C17.7103 18.5507 17.8636 19.1174 18.1503 19.6174L17.6836 21.3307L19.4336 20.8707C19.9169 21.1341 20.4603 21.2741 21.0136 21.2741C22.8336 21.2741 24.3169 19.7907 24.3169 17.9707C24.3169 17.0874 23.9736 16.2574 23.3503 15.6341ZM21.0136 20.7141C20.5203 20.7141 20.0369 20.5807 19.6136 20.3307L19.5136 20.2707L18.4736 20.5441L18.7503 19.5307L18.6836 19.4274C18.4095 18.9897 18.264 18.4838 18.2636 17.9674C18.2636 16.4541 19.4969 15.2207 21.0103 15.2207C21.7436 15.2207 22.4336 15.5074 22.9503 16.0274C23.2061 16.2821 23.4088 16.585 23.5467 16.9186C23.6846 17.2521 23.7549 17.6098 23.7536 17.9707C23.7603 19.4841 22.5269 20.7141 21.0136 20.7141ZM22.5203 18.6607C22.4369 18.6207 22.0303 18.4207 21.9569 18.3907C21.8803 18.3641 21.8269 18.3507 21.7703 18.4307C21.7136 18.5141 21.5569 18.7007 21.5103 18.7541C21.4636 18.8107 21.4136 18.8174 21.3303 18.7741C21.2469 18.7341 20.9803 18.6441 20.6669 18.3641C20.4203 18.1441 20.2569 17.8741 20.2069 17.7907C20.1603 17.7074 20.2003 17.6641 20.2436 17.6207C20.2803 17.5841 20.3269 17.5241 20.3669 17.4774C20.4069 17.4307 20.4236 17.3941 20.4503 17.3407C20.4769 17.2841 20.4636 17.2374 20.4436 17.1974C20.4236 17.1574 20.2569 16.7507 20.1903 16.5841C20.1236 16.4241 20.0536 16.4441 20.0036 16.4407H19.8436C19.7869 16.4407 19.7003 16.4607 19.6236 16.5441C19.5503 16.6274 19.3369 16.8274 19.3369 17.2341C19.3369 17.6407 19.6336 18.0341 19.6736 18.0874C19.7136 18.1441 20.2569 18.9774 21.0836 19.3341C21.2803 19.4207 21.4336 19.4707 21.5536 19.5074C21.7503 19.5707 21.9303 19.5607 22.0736 19.5407C22.2336 19.5174 22.5636 19.3407 22.6303 19.1474C22.7003 18.9541 22.7003 18.7907 22.6769 18.7541C22.6536 18.7174 22.6036 18.7007 22.5203 18.6607Z",
    fill: "#FFF4F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_937_16323)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 66,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 72,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 76,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_937_16323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 56.375L59.375 56.375L59.375 55L58.625 55ZM58.625 57.2917L58.625 60.0417L59.375 60.0417L59.375 57.2917L58.625 57.2917ZM58.625 60.9583L58.625 63.7083L59.375 63.7083L59.375 60.9583L58.625 60.9583ZM58.625 64.625L58.625 66L59.375 66L59.375 64.625L58.625 64.625Z",
    fill: "#7DB9FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 57.2917L59.375 57.2917L59.375 55L58.625 55ZM58.625 58.2083L58.625 62.7917L59.375 62.7917L59.375 58.2083L58.625 58.2083ZM58.625 63.7083L58.625 66L59.375 66L59.375 63.7083L58.625 63.7083Z",
    fill: "#42CFEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_937_16323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "5 1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_937_16323)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 46.75,
    r: 6.75,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3472 44.8843C61.1716 43.0618 58.7641 42.5218 56.9022 43.6524C55.0854 44.783 54.5004 47.2468 55.676 49.0636L55.7716 49.2099L55.3779 50.6836L56.8516 50.2899L56.9979 50.3855C57.6335 50.7286 58.3254 50.9255 59.0116 50.9255C59.7485 50.9255 60.4854 50.7286 61.121 50.3349C62.9379 49.1536 63.4779 46.7405 62.3472 44.873V44.8843ZM61.3179 48.6755C61.121 48.968 60.8735 49.1649 60.5304 49.2155C60.3335 49.2155 60.086 49.3111 59.1072 48.923C58.2747 48.5293 57.5829 47.888 57.0935 47.1511C56.801 46.808 56.6491 46.3636 56.6041 45.9193C56.6041 45.5255 56.7504 45.1824 56.9979 44.9349C57.0935 44.8393 57.1947 44.7886 57.2904 44.7886H57.5379C57.6335 44.7886 57.7347 44.7886 57.7854 44.9855C57.881 45.233 58.1285 45.8236 58.1285 45.8743C58.1791 45.9249 58.1566 46.3018 57.9316 46.5155C57.8079 46.6561 57.7854 46.6618 57.836 46.763C58.0329 47.0555 58.2804 47.3536 58.5222 47.6011C58.8147 47.8486 59.1129 48.0455 59.456 48.1918C59.5516 48.2424 59.6529 48.2424 59.7035 48.1411C59.7541 48.0455 59.996 47.798 60.0972 47.6968C60.1929 47.6011 60.2435 47.6011 60.3447 47.6461L61.1322 48.0399C61.2279 48.0905 61.3291 48.1355 61.3797 48.1861C61.4304 48.3324 61.4304 48.5293 61.3291 48.6755H61.3179Z",
    fill: "#394353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_937_16323",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_16323"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_16323"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_16323",
    result: "effect2_dropShadow_937_16323"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_16323",
    result: "effect3_dropShadow_937_16323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_16323",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_937_16323",
    x: 0,
    y: 60,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_16323"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_16323"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_16323",
    result: "effect2_dropShadow_937_16323"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_16323",
    result: "effect3_dropShadow_937_16323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_16323",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_937_16323",
    x: 48.2383,
    y: 47,
    width: 21.5234,
    height: 27.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_16323"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_937_16323",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_16323"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_937_16323",
    x: 47.126,
    y: 35.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_937_16323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_16323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappNode);
export default __webpack_public_path__ + "static/media/whatsappNode.d72af52a950ef3db1c9bf92e04ab01b3.svg";
export { ForwardRef as ReactComponent };